import PropTypes from 'prop-types';
import React from 'react';
import locale from '@glu/locale';
import { AccessibilityText } from '@glu/utilities-react';
import StyledSelect from './StyledSelect';

const SelectMonths = ({ head, index, onChange }) => {
  const months = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
  ];
  const selectedMonth = head.format('MMM').toLowerCase();
  return (
    <StyledSelect>
      <label htmlFor={`select-month-${index}`}>
        <AccessibilityText>Months</AccessibilityText>
        <select
          data-qa={`select-month-${index}`}
          id={`select-month-${index}`}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          value={selectedMonth}
        >
          {months.map((value, monthIndex) => (
            <option key={value} value={value}>
              {locale.get(`month${monthIndex + 1}`)}
            </option>
          ))}
        </select>
      </label>
    </StyledSelect>
  );
};

SelectMonths.propTypes = {
  head: PropTypes.shape({
    format: PropTypes.func,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectMonths;
